import styled, { css, keyframes } from 'styled-components';
import {
  MdError,
  MdCheckCircle,
  MdCancel,
  MdHelp,
  MdNotInterested,
} from 'react-icons/md';

import themes from '../../../styles/theme';

const rotate = keyframes`
    from{
        transform: rotate(0deg);
    }

    to{
        transform: rotate(360deg);
    }
`;

export const TableContentWrapper = styled.div`
  background-color: ${themes.bgWhite};
  padding: 30px;
  width: 100%;

  max-height: ${({ maxHeight }) => maxHeight || '540px'};
  min-height: ${({ minHeight }) => minHeight || '280px'};

  height: ${({ height }) => height || '100%'};
`;

export const ContentWrapper = styled.div`
  overflow-x: scroll;

  ::-webkit-scrollbar {
    border-radius: 3px;
    height: 6px;
    width: 800px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: ${themes.grey};
  }
`;

export const ContainerEmptyContent = styled.div`
  text-align: left;
  font: 500 16px 'Calibri';
  letter-spacing: 1.12px;
  color: ${themes.titleGray};
  opacity: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  margin-top: 80px;

  svg {
    animation: ${rotate} 2s linear infinite;
  }
`;

export const IconWarning = styled(MdError)`
  height: 22.52px;
  width: 22.52px;
  fill: ${themes.yellowDefault};
  margin-right: 7px;
`;

export const IconAccepted = styled(MdCheckCircle)`
  height: 22.24px;
  width: 22.24px;
  fill: ${themes.greenDefault};
  margin-right: 8px;
`;
export const IconError = styled(MdCancel)`
  height: 22.24px;
  width: 22.24px;
  fill: ${themes.red};
  margin-right: 8px;
`;

export const IconOptional = styled(MdHelp)`
  height: 22.3px;
  width: 22.3px;
  fill: ${themes.blueDefault};
  margin-right: 8px;
`;

export const IconNotSend = styled(MdNotInterested)`
  height: 22.24px;
  width: 22.24px;
  margin-right: 8px;
`;

export const Text = styled.span`
  &:hover {
    text-decoration: underline;
  }
  ${({ marginRight }) =>
    marginRight
      ? css`
          margin-right: ${marginRight};
        `
      : ''}

  ${({ cursorPointer }) =>
    cursorPointer
      ? css`
          cursor: pointer;
        `
      : css`
          cursor: not-allowed;
        `}
`;

export const WrapperContentTable = styled.div`
  ${({ width }) =>
    width
      ? css`
          width: ${width} !important;
        `
      : ''}
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
